export enum CalType {
    COMMUNITY = 'COMMUNITY',
    ORGANIZATION = 'ORGANIZATION',
    DEPARTMENT = 'DEPARTMENT'
}
